/**
 * 手动检索保存请求参数
 */
export interface ManualSearchSaveRequest {
    /**
     * 任务ID
     */
    task_id: string;

    /**
     * 别名query
     */
    alias_query: string;

    /**
     * 实际query内容
     */
    query: string;

    /**
     * 查询编号
     */
    query_no: string;

    /**
     * 数量
     */
    count: number;

    /**
     * 使用的查询编号
     */
    using_query_no: string[];

    /**
     * 专利ID列表
     */
    patent_ids: string[];
}

/**
 * 手动检索保存响应结果
 */
export interface ManualSearchSaveResponse {
    /**
     * 是否成功
     */
    success: boolean;

    /**
     * 已保存的专利ID列表
     */
    saved_patent_ids: string[];
}

/**
 * 手动检索保存API接口
 * @description 用于保存手动检索结果的API接口定义
 */
export const ManualSearchSaveApi = Symbol.for('ManualSearchSaveApi');

/**
 * 手动检索保存API接口
 */
export interface ManualSearchSaveApi {
    /**
     * 保存手动检索结果
     * @param data 手动检索保存请求参数
     * @returns 保存结果的响应
     * @description 保存手动检索的专利结果到指定任务
     */
    saveManualSearchResult(data: ManualSearchSaveRequest): Promise<ManualSearchSaveResponse>;
}
